export default function LegalPage() {
  return (
    <main>
      {/* Hero */}
      <section className="relative pt-32 pb-16 md:pt-40 md:pb-20 bg-background-50">
        <div className="max-w-[1440px] mx-auto px-6 md:px-12">
          <div className="max-w-3xl">
            <span className="text-[10px] uppercase tracking-[3px] text-primary-500 font-semibold">
              Legal Information
            </span>
            <h1 className="text-5xl md:text-7xl font-heading font-bold text-foreground-950 mt-4 mb-6 tracking-tight">
              Legal & Imprint
            </h1>
          </div>
        </div>
      </section>

      {/* Content */}
      <section className="relative py-16 md:py-24 bg-white">
        <div className="max-w-[1440px] mx-auto px-6 md:px-12">
          <div className="max-w-3xl mx-auto flex flex-col gap-12">
            {/* Imprint */}
            <div>
              <h2 className="text-2xl font-heading font-bold text-foreground-950 mb-6">Imprint</h2>
              <div className="bg-background-50 rounded-xl p-6 border border-foreground-100/20">
                <p className="text-foreground-600 text-sm leading-relaxed mb-1"><strong>Company Name:</strong> Creighton Investments Ltd</p>
                <p className="text-foreground-600 text-sm leading-relaxed mb-1"><strong>Legal Form:</strong> Private Limited Company (Ltd)</p>
                <p className="text-foreground-600 text-sm leading-relaxed mb-1"><strong>Company Number:</strong> 10256484</p>
                <p className="text-foreground-600 text-sm leading-relaxed mb-1"><strong>Incorporated:</strong> 29 June 2016</p>
                <p className="text-foreground-600 text-sm leading-relaxed mb-1"><strong>Address:</strong> 12 Gateway Mews, Bounds Green, London, N11 2UT, United Kingdom</p>
                <p className="text-foreground-600 text-sm leading-relaxed mb-1"><strong>Sector:</strong> Activities of other holding companies not elsewhere classified (SIC 64209)</p>
                <p className="text-foreground-600 text-sm leading-relaxed"><strong>Contact:</strong> info@creightoninvest.com</p>
              </div>
            </div>

            {/* Privacy Policy */}
            <div>
              <h2 className="text-2xl font-heading font-bold text-foreground-950 mb-6">Privacy Policy</h2>
              <div className="flex flex-col gap-4 text-foreground-600 text-sm leading-relaxed">
                <p>
                  Creighton Investments Ltd (&ldquo;we,&rdquo; &ldquo;us,&rdquo; or &ldquo;our&rdquo;) is committed to protecting your personal data. This Privacy Policy explains how we collect, use, and safeguard information when you visit our website or communicate with us.
                </p>
                <p>
                  We collect only the personal information you voluntarily provide through our contact forms — including name, email address, phone number, organization, and investment interests. This information is used solely to respond to your inquiries and manage investor relations.
                </p>
                <p>
                  We do not sell, rent, or share your personal data with third parties for marketing purposes. Your data may be processed by our service providers solely for the purpose of operating our website and communications infrastructure, in compliance with UK data protection law.
                </p>
                <p>
                  You have the right to request access to, correction of, or deletion of your personal data at any time. Please contact us at info@creightoninvest.com for any privacy-related inquiries.
                </p>
              </div>
            </div>

            {/* Terms of Use */}
            <div>
              <h2 className="text-2xl font-heading font-bold text-foreground-950 mb-6">Terms of Use</h2>
              <div className="flex flex-col gap-4 text-foreground-600 text-sm leading-relaxed">
                <p>
                  By accessing this website, you agree to these Terms of Use. The content on this website is provided for informational purposes only and does not constitute investment advice, an offer, or a solicitation to buy or sell any financial instrument.
                </p>
                <p>
                  All investments involve risk, including potential loss of principal. Past performance is not indicative of future results. Any performance data presented is net of fees and represents historical performance only.
                </p>
                <p>
                  This website and its content are directed exclusively at professional and accredited investors as defined under applicable UK and European regulations. It is not intended for retail investors or the general public.
                </p>
              </div>
            </div>

            {/* Disclaimer */}
            <div>
              <h2 className="text-2xl font-heading font-bold text-foreground-950 mb-6">Disclaimer</h2>
              <div className="bg-background-50 rounded-xl p-6 border border-foreground-100/20">
                <p className="text-foreground-600 text-sm leading-relaxed mb-3">
                  The information on this website is for general informational purposes only. Creighton Investments Ltd makes no representations or warranties of any kind, express or implied, about the completeness, accuracy, reliability, suitability, or availability of the information contained on the website.
                </p>
                <p className="text-foreground-600 text-sm leading-relaxed">
                  In no event shall Creighton Investments Ltd be liable for any loss or damage arising from the use of this website or reliance on its content. Investment decisions should be made only after consultation with qualified professional advisors and thorough due diligence.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}